export default __webpack_public_path__ + "static/media/ProtectPromoteIcon.7f3e8f76.svg";